import {Component, Input, OnInit} from '@angular/core';
import {ItemManagmentService} from '../../../Shared/services/item-managment-service';
import { Item } from '../../../generated/graphql';
import { ChecklistCardComponent } from '../checklist-card/checklist-card.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
  imports: [CommonModule, ChecklistCardComponent]
})
export class ChecklistComponent implements OnInit {
  @Input()
  itemDetail: Item;

  @Input()
  loading: boolean = false;

  constructor(public itemManagementService: ItemManagmentService) {}

  ngOnInit(): void {}
}
